.inline {
  color: var(--mantine-color-red-4);
}

.inline-title {
  font-weight: 600;
}

.inline-message {
  margin-top: var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-dimmed);
}

.minimal {
  display: inline;
  color: inherit;
}
